// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poster-carousel {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  z-index: 1;
  touch-action: pan-y;
  -webkit-user-select: none;
  user-select: none;
}

.poster-track {
  will-change: transform;
  cursor: grab;
}

.poster-track:active {
  cursor: grabbing;
}

.poster-item {
  box-sizing: border-box;
  height: 240px; /* Reduced height for poster items */
  display: flex;
  align-items: center;
  justify-content: center;
}

.poster-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Make images cover the container */
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  cursor: pointer;
  transition: transform 0.2s;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.poster-image:hover {
  transform: scale(1.10);
}

/* Make sure total height is tall enough to scroll smoothly */
@keyframes scrollLoop {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-50%);
  }
}

/* Modal styles — unchanged */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  position: relative;
}

.modal-image {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 12px;
  border: 10px solid white;
}

.close-button {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #fff;
  border: none;
  font-size: 1.5rem;
  padding: 0.3rem 0.6rem;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 5px #000;
}

/* Large Tablets and Small Desktops */
@media screen and (max-width: 1024px) {
  .poster-carousel {
    width: 100%;
    height: auto;
    position: relative;
    margin: 0;
    padding: 0;
  }
  
  .poster-item {
    width: 180px !important;
    height: 220px !important;
  }
}

/* Tablets */
@media screen and (max-width: 768px) {
  .poster-item {
    width: 140px !important;
    height: 180px !important;
  }
}

/* Large Phones */
@media screen and (max-width: 576px) {
  .poster-item {
    width: 130px !important;
    height: 170px !important;
  }
}

/* Medium Phones */
@media screen and (max-width: 480px) {
  .poster-item {
    width: 120px !important;
    height: 160px !important;
  }
}

/* Small Phones */
@media screen and (max-width: 375px) {
  .poster-item {
    width: 150px !important;
    height: 220px !important;
  }
}

/* Extra Small Phones */
@media screen and (max-width: 320px) {
  .poster-item {
    width: 120px !important;
    height: 160px !important;
  }
}

/* Common styles for all mobile devices */
@media screen and (max-width: 1024px) {
  .poster-image {
    margin: 0;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  .modal-image {
    max-width: 95vw;
    max-height: 80vh;
    border: 8px solid white;
  }

  .close-button {
    top: -15px;
    right: -15px;
    font-size: 1.2rem;
    padding: 0.2rem 0.5rem;
  }
}

/* Bottom-positioned carousel in Home page */
.bottom-carousel .poster-carousel {
  position: relative;
  width: 100%;
  height: 250px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.bottom-carousel .poster-track {
  /* Force the track to be visible */
  opacity: 1;
  visibility: visible;
  position: relative;
}

.bottom-carousel .poster-item {
  height: 220px; /* Reduced height */
}

@media screen and (max-width: 768px) {
  .bottom-carousel .poster-carousel {
    height: 200px; /* Reduced height */
  }
  
  .bottom-carousel .poster-item {
    height: 180px; /* Reduced height */
    width: 140px !important; /* Smaller width on mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/PosterCarousel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa,EAAE,oCAAoC;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,oCAAoC;EACvD,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,YAAY;AACZ;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,mBAAmB;AACpC;;AAEA;EACE;IACE,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,aAAa,EAAE,mBAAmB;IAClC,uBAAuB,EAAE,4BAA4B;EACvD;AACF","sourcesContent":[".poster-carousel {\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  touch-action: pan-y;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.poster-track {\n  will-change: transform;\n  cursor: grab;\n}\n\n.poster-track:active {\n  cursor: grabbing;\n}\n\n.poster-item {\n  box-sizing: border-box;\n  height: 240px; /* Reduced height for poster items */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.poster-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Make images cover the container */\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n  cursor: pointer;\n  transition: transform 0.2s;\n  backface-visibility: hidden;\n  transform: translateZ(0);\n}\n\n.poster-image:hover {\n  transform: scale(1.10);\n}\n\n/* Make sure total height is tall enough to scroll smoothly */\n@keyframes scrollLoop {\n  0% {\n    transform: translateY(0%);\n  }\n  100% {\n    transform: translateY(-50%);\n  }\n}\n\n/* Modal styles — unchanged */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal-content {\n  position: relative;\n}\n\n.modal-image {\n  max-width: 90vw;\n  max-height: 90vh;\n  border-radius: 12px;\n  border: 10px solid white;\n}\n\n.close-button {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background: #fff;\n  border: none;\n  font-size: 1.5rem;\n  padding: 0.3rem 0.6rem;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 0 5px #000;\n}\n\n/* Large Tablets and Small Desktops */\n@media screen and (max-width: 1024px) {\n  .poster-carousel {\n    width: 100%;\n    height: auto;\n    position: relative;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .poster-item {\n    width: 180px !important;\n    height: 220px !important;\n  }\n}\n\n/* Tablets */\n@media screen and (max-width: 768px) {\n  .poster-item {\n    width: 140px !important;\n    height: 180px !important;\n  }\n}\n\n/* Large Phones */\n@media screen and (max-width: 576px) {\n  .poster-item {\n    width: 130px !important;\n    height: 170px !important;\n  }\n}\n\n/* Medium Phones */\n@media screen and (max-width: 480px) {\n  .poster-item {\n    width: 120px !important;\n    height: 160px !important;\n  }\n}\n\n/* Small Phones */\n@media screen and (max-width: 375px) {\n  .poster-item {\n    width: 150px !important;\n    height: 220px !important;\n  }\n}\n\n/* Extra Small Phones */\n@media screen and (max-width: 320px) {\n  .poster-item {\n    width: 120px !important;\n    height: 160px !important;\n  }\n}\n\n/* Common styles for all mobile devices */\n@media screen and (max-width: 1024px) {\n  .poster-image {\n    margin: 0;\n    object-fit: cover;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  }\n\n  .modal-image {\n    max-width: 95vw;\n    max-height: 80vh;\n    border: 8px solid white;\n  }\n\n  .close-button {\n    top: -15px;\n    right: -15px;\n    font-size: 1.2rem;\n    padding: 0.2rem 0.5rem;\n  }\n}\n\n/* Bottom-positioned carousel in Home page */\n.bottom-carousel .poster-carousel {\n  position: relative;\n  width: 100%;\n  height: 250px;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.bottom-carousel .poster-track {\n  /* Force the track to be visible */\n  opacity: 1;\n  visibility: visible;\n  position: relative;\n}\n\n.bottom-carousel .poster-item {\n  height: 220px; /* Reduced height */\n}\n\n@media screen and (max-width: 768px) {\n  .bottom-carousel .poster-carousel {\n    height: 200px; /* Reduced height */\n  }\n  \n  .bottom-carousel .poster-item {\n    height: 180px; /* Reduced height */\n    width: 140px !important; /* Smaller width on mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
